import { useQuery } from '@tanstack/react-query'
import { transcriptionApi } from '../../utils/api'
import type { TranscriptionStatus } from '../../types'

/**
 * ポーリング間隔の判定（純関数・テスト容易性のため分離）。
 * - エラー状態なら停止（古い成功データの status が pending/processing のまま残って
 *   無限再取得になるのを防ぐ）。
 * - status が pending/processing の間のみ 3秒。completed/partial/failed/cancelled は停止
 *   （現行 setInterval の停止条件と同一。cancelled は現行同様停止対象＝ポーリングしない）。
 */
export function transcriptionPollInterval(
  status: TranscriptionStatus | undefined,
  isError: boolean,
): number | false {
  if (isError) return false
  return status === 'pending' || status === 'processing' ? 3000 : false
}

/**
 * 書き起こし詳細の取得＋ポーリング（TranscriptionPage）。
 */
export function useTranscription(id: string | undefined) {
  return useQuery({
    queryKey: ['transcription', id],
    queryFn: () => transcriptionApi.get(id as string),
    enabled: !!id,
    refetchInterval: (query) =>
      transcriptionPollInterval(query.state.data?.status, query.state.status === 'error'),
  })
}
